/**
 * index.js
 *
 * @Author: apple
 * @Date: 2018/1/22 22:49
 */

import React from 'react';
import Loading from './Loading';

export const LoadingWarp = Component =>
  class extends React.Component {
    render() {
      const { loading, ...other } = this.props;
      return (
        <Loading show={!!loading}>
          <Component {...other} />
        </Loading>
      );
    }
  };

export default Loading;



// WEBPACK FOOTER //
// ./src/loading/index.js